import { Box, Tab, Tabs, useTheme } from "@mui/material"
import { useState } from "react"
import PageHeader from "../../../components/PageHeader"
import { infectionControlIcon } from "../../../icons"
import BiologicalCalendar from "./calendar/BiologicalCalendar"
import BiologicalInventory from "./inventory/BiologicalInventory"

const BiologicalMonitoring = () => {
  const theme = useTheme()

  const [tabIndex, setTabIndex] = useState(0)

  const pageTabs = ['Test Results', 'Inventory']

  const handleTabChange: ((event: React.SyntheticEvent, value: any) => void) = (event, newValue) => {
    setTabIndex(newValue)
  }

  const tabPages = [
    <BiologicalCalendar key="0" />,
    <BiologicalInventory key="1" />
  ]

  return (
    <>
      <PageHeader src={infectionControlIcon} headerName={'Biological Monitoring'} size={'26px'} />
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className={'flex flex-space-between flex-align-center'}>
        <Tabs value={tabIndex} onChange={handleTabChange}>
          {
            pageTabs.length && pageTabs.map((tab, index) => (
              <Tab key={index} label={tab} />
            ))
          }
        </Tabs>
      </Box>
      <Box sx={{ width: '100%', p: 2, color: theme.palette.color50555b.main }} className="corp-waterline-container">
        {
          tabPages.length && tabPages.filter((page, index) => index === tabIndex)
        }
      </Box>
    </>
  )
}

export default BiologicalMonitoring